/**
 * Default indirect verification = all profile HQ countries minus those with a dedicated
 * registry API in the server verification orchestrator (before KYB).
 *
 * HQ names come from `getAllProfileHeadquartersCountryNames()` in
 * `profileHeadquartersCountries.ts` (also drives web `countriesData`).
 */

import { getAllProfileHeadquartersCountryNames } from "./profileHeadquartersCountries";

/** HQ names excluded: Gridlines (IN), NZ/TW/UK/NO registries, EU members (VIES + EU_VAT UI). */
export const HEADQUARTERS_EXCLUDED_FROM_INDIRECT_VERIFICATION_DEFAULT: readonly string[] = [
  "India",
  "New Zealand",
  "Taiwan",
  "United Kingdom",
  "Norway",
  "Austria",
  "Belgium",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "Poland",
  "Portugal",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
];

/**
 * Every HQ select value / `Company.headquartersCountry` (full world minus blocked).
 */
export const ALL_PROFILE_HEADQUARTERS_COUNTRY_NAMES: readonly string[] =
  getAllProfileHeadquartersCountryNames();

export function getDefaultIndirectVerificationCountryNames(): string[] {
  const excluded = new Set(HEADQUARTERS_EXCLUDED_FROM_INDIRECT_VERIFICATION_DEFAULT);
  return ALL_PROFILE_HEADQUARTERS_COUNTRY_NAMES.filter((n) => !excluded.has(n));
}
